"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Text = exports.Root = exports.IconWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _reactRouterDom = require("react-router-dom");
const Root = exports.Root = (0, _mui.styled)(_reactRouterDom.Link)((param)=>{
    let { theme } = param;
    return {
        boxSizing: 'border-box',
        flexBasis: 320,
        height: 150,
        marginBottom: theme.spacing(4),
        padding: theme.spacing(6, 3, 4),
        transition: 'box-shadow 0.2s',
        borderRadius: theme.spacing(1),
        opacity: 1,
        backgroundColor: theme.palette.common.white,
        boxShadow: _mui.SHADOW_LEVEL2,
        textAlign: 'center',
        textDecoration: 'none',
        '&:hover': {
            boxShadow: _mui.SHADOW_LEVEL3
        },
        [theme.breakpoints.up(733)]: {
            marginBottom: theme.spacing(2),
            '& + &': {
                marginLeft: theme.spacing(2)
            }
        },
        [theme.breakpoints.between(733, 1081)]: {
            '&:nth-of-type(2n + 3)': {
                marginLeft: 0
            }
        },
        [theme.breakpoints.up(1081)]: {
            '&:nth-of-type(3n + 4)': {
                marginLeft: 0
            }
        }
    };
});
const IconWrapper = exports.IconWrapper = (0, _mui.styled)('span')((param)=>{
    let { theme } = param;
    return {
        display: 'inline-block',
        width: 70,
        height: 45,
        margin: theme.spacing(0, 'auto', 4),
        color: '#4c919c',
        fontSize: '5.7rem',
        lineHeight: '4rem'
    };
});
const Text = exports.Text = (0, _mui.styled)('p')((param)=>{
    let { theme } = param;
    return {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        margin: 0,
        overflow: 'hidden',
        color: theme.palette.text.secondary,
        fontSize: '1.4rem',
        fontWeight: theme.typography.fontWeightBold,
        lineHeight: '1.9rem'
    };
});
